import { CLEAR_EMBEDDED_DATA } from 'root/src/client/logic/embedded/actionIds'

export default moduleId => ({
	type: CLEAR_EMBEDDED_DATA,
	payload: {
		moduleId,
	},
})
